import { Injectable } from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';
import { RestService } from './rest.service';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public authenticatedUser$ = new Subject<boolean>();
  public authenticatedNewUser$ = new Subject<boolean>();
  public authenticatedAdm$ = new Subject<boolean>();
  public authenticatedUser: boolean;
  private user: IUser;
  private parameters = null;

  constructor(
    private restService: RestService
  ) { }

  public authUser(userEmail: string): void {
    if (userEmail.toLocaleLowerCase().trim() === environment.usuarioFantasma) {
      this.user = { name: 'Administrador', email: '', key: '', bag: [] }
      setTimeout(() => {
        this.authenticatedUser = true;
        this.authenticatedUser$.next(true);
      }, 1000);
      
    } else {
      const subscription$: Subscription = this.restService.getUser().subscribe(users => {
        const usuarioEncontrado = users.filter((user: any) => user.email === userEmail.toLocaleLowerCase().trim());
        if (usuarioEncontrado.length > 0) {
          this.user = usuarioEncontrado[0];
          this.authenticatedUser = true;
          this.authenticatedUser$.next(true);
          const now = new Date();
          const userHistoric = {
            ...usuarioEncontrado[0],
            date: this.getDateNow(),
            hour: `${now.getHours() < 10 ? '0'+now.getHours() : now.getHours()}:${now.getMinutes() < 10 ? '0'+now.getMinutes() : now.getMinutes()}`
          }
          delete userHistoric.key;
          this.setUserHistoric(userHistoric);
        } else {
          this.authenticatedUser = false;
          this.authenticatedUser$.next(false);
        }
        subscription$.unsubscribe();
      });
    }
  }

  private getDateNow(): string {
    const now = new Date;
    // const day = now.getDate() < 10 ? ("0" + (now.getDate() + 1)).slice(-2) : now.getDate();
    const day = now.getDate() < 10 ? ("0" + now.getDate()).slice(-2) : now.getDate();
    const month = now.getMonth() < 10 ? ("0" + (now.getMonth() + 1)).slice(-2) : now.getMonth();
    const year = now.getFullYear();
    return day + '/' + month + "/" + year;
  }

  public registerNewUser(userData: any, userHistoric: any): void {
    this.restService.addUser(userData).then((res: any) => {
      const userKey = res.path.pieces_.filter((item) => item[0] === '-')[0];
      if (userKey) {
        userData.key = userKey;
        console.log('Novo usuário cadastrado: ', userKey);
        this.user = userData;
        this.authenticatedUser = true;
        this.authenticatedNewUser$.next(true);
        this.setUserHistoric(userHistoric);
      }
    });
  }

  public getAuthUser(): boolean {
    return this.authenticatedUser;
  }

  public getUser(): IUser {
    return this.user;
  }

  public authAdmUser(credentials): boolean {
    let auth: boolean;
    const subscription$: Subscription = this.restService.getAdmUser().subscribe(result => {
      // console.log('USER: ', result);
      if (result[0].user === credentials.user && result[0].password === credentials.password) {
        console.log('credentials IF: ', credentials);
        auth = true;
        this.authenticatedUser = true;
        this.authenticatedAdm$.next(true);
      } else {
        console.log('credentials ELSE: ', credentials);
        this.authenticatedAdm$.next(false);
        auth = false;
      }
      subscription$.unsubscribe();
    });
    return auth;
  }

  public setAdmUser(credential): void {
    this.restService.setAdmUser(credential);
  }

  public setUserHistoric(user) {
    this.restService.setUserHistoric(user);
  }

  public getParameters() {
    return this.parameters;
  }

  public setParameters(params) {
    this.parameters = params;
  }
}
